import React, { Component } from "react";
import Back from "../images/back.svg";
import table from "../images/table.svg";
import takeaway from "../images/takeaway.svg";
import NewFood from "../images/newfood.svg";
import Cancel from "../images/cancel.svg";
import Tick from "../images/tick.svg";
import Logout from "../images/logout.svg";
import Profilee from "../images/profile.svg";
import CustomButton from "./CustomButton";
import CashierDateTime from "./CashierDateTime";
import Loading from "./Loading";
import { WhisperSpinner, ImpulseSpinner } from "react-spinners-kit";
import noimage from "../images/noimage.jpg";
import { toast } from "react-toastify";
import ScrollContainer from "react-indiana-drag-scroll";
import plus from "../images/plusPrimary.svg";
import minus from "../images/minusPrimary.svg";
import { Modal } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { Form } from "react-bootstrap";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import Button from "@mui/material/Button";
// import momentjalali from "moment-jalaali";
import { Icon } from "@iconify/react";
import baselineSearch from "@iconify/icons-ic/baseline-search";
import baselineClose from "@iconify/icons-ic/baseline-close";
import outlineKeyboard from "@iconify/icons-ic/outline-keyboard";
import baselineKeyboard from "@iconify/icons-ic/baseline-keyboard";
import TableItem from "./TableItem";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
// import LinesEllipsis from "react-lines-ellipsis";
import Truncate from "react-truncate";
import deleteIcon from "@iconify/icons-mi/delete";
import baselineMinus from "@iconify/icons-ic/baseline-minus";
import baselinePlus from "@iconify/icons-ic/baseline-plus";
import roundPerson from "@iconify/icons-ic/round-person";

import {
  BaseUrl,
  Authorization,
  BaseUrlAssets,
  BaseUrlPublic,
  LogoutFunction,
  ServerSocket,
} from "../static.js";
import Tooltip from "@mui/material/Tooltip";

const mobileRegex = RegExp(/09(0[1-9]|1[0-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class Cashier extends Component {
  constructor(props) {
    super(props);

    let currentOrder = [];
    if (this.props.currentOrder && this.props.currentOrder.length > 0) {
      currentOrder = JSON.parse(JSON.stringify(this.props.currentOrder));
      currentOrder.forEach((element) => {
        element.name = element.foodName;
        element.itemId = element.id;
        element.id = element.foodId;
      });
    }

    console.log("currentOrderInfo:", this.props.currentOrderInfo);
    console.log("currentOrderDes:", this.props.currentOrderDes);

    this.state = {
      Cats: [],
      Foods: [],
      catActiveIndex: -1,
      loading: true,
      currentOrderStatus: this.props.currentOrderStatus,
      currentOrderId: this.props.currentOrderId,
      currentOrder: currentOrder,
      currentOrderInfo: this.props.currentOrderInfo,
      shoppingList: currentOrder,
      searchValue: "",
      totalPrice: 0,
      sumItem: 0,
      extrasPrice: 0,
      servicePrice: 0,
      deliveryPrice: 0,
      packingPrice: 0,
      discountPrice: 0,
      taxPrice: 0,
      // dateValue: momentjalali().format("jYYYY/jM/jD"),
      // timeValue: momentjalali().format("HH:mm"),
      mobileValue: this.props.currentOrderInfo?.customerMobile?.replace(
        "+98",
        "0"
      ),
      mobileValueErrorText: "",
      doneLoading: false,
      ModalInfoShow: false,
      ModalDesShow: false,
      invoiceLoading: false,
      desValue: this.props.currentOrderDes ? this.props.currentOrderDes : "",
      settlementType: this.props.settlementType ? this.props.settlementType : 5,
      windowWidth: 0,
      showSearchField: false,
      ModalDeleteChanges: false,
      ModalGuestsShow: false,
      numberOfGuests: this.props.numberOfGuests
        ? this.props.numberOfGuests
        : null,
      selectedTableId: this.props.currentorderStationId,
      selectedTableName: this.props.orderStationName,
      tablesList: [],
      keyboardLayoutName: "default",
      keyboardPositionLeft: 0,
      keyboardPositionTop: 0,
      keyboard: false,
      currentInputTarget: null,
      keyboardOpacity: 0,
      currentItemQuantitySelected: null,
      keyboardMode: false,
      defaultLanguage: this.props.languageId,
      ModalDeleteOrder: false,
      ModalTableShow: false,
      SubmitAfterTable: false,
      SubmitAfterCheckout: false,
      ModalCheckout: false,
    };
    // setInterval(() => {
    //   this.setState({
    //     dateValue: momentjalali().format("jYYYY/jM/jD"),
    //     timeValue: momentjalali().format("HH:mm"),
    //   });
    // }, 1000);

    this.mobileRef = React.createRef();
    this.desRef = React.createRef();
    this.searchRef = React.createRef();
    this.guestsRef = React.createRef();
    this.keyboardContainer = React.createRef();
    this.keyboardObject = React.createRef();
    this.quantityRef = React.createRef();

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.onConfirmQuantity = this.onConfirmQuantity.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.shoppingList !== this.state.shoppingList &&
      this.state.shoppingList &&
      this.state.shoppingList.length > 0
    )
      this.invoiceCalculator();

    if (
      prevState.shoppingList !== this.state.shoppingList &&
      this.state.shoppingList.length < 1
    )
      this.setState({ desValue: "" });

    if (prevState.searchValue !== this.state.searchValue) {
      let foods = [];
      this.setState({ catActiveIndex: -1 });
      if (this.state.searchValue.trim())
        this.state.Cats.forEach((element) => {
          element.items.forEach((element1) => {
            if (
              element1.name
                .toLowerCase()
                .indexOf(this.state.searchValue.toLowerCase()) > -1
            ) {
              foods.push(element1);
            }
          });
        });

      this.setState({ Foods: foods });
    }
  }

  invoiceCalculator() {
    if (this.state.shoppingList.length < 1) return;
    console.log(this.state.shoppingList);
    let newItems = [];
    this.state.shoppingList.forEach((element) => {
      newItems.push({ quantity: element.quantity, foodId: element.id });
    });
    let newmobile = this.state.mobileValue;
    if (newmobile && newmobile.toString().startsWith("0")) {
      newmobile = newmobile.substring(1);
      newmobile = "+98" + newmobile;
    }
    let data = {
      orderStationId: 5,
      businessId: this.props.resID,
      businessCode: this.props.businessCode,
      items: newItems,
      discount: 0,
      customerMobile: newmobile ? newmobile : "",
    };
    data = Object.assign(data, Authorization());
    this.setState({ invoiceLoading: true });
    console.log(data);
    fetch(BaseUrl + "invoiceCalculator", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("invoiceCalculator Result:", result);
        if (result.status === 200) {
          this.setState({
            totalPrice: result.invoice.sum,
            sumItem: result.invoice.sumItem,
            taxPrice: result.invoice.tax,
            servicePrice: result.invoice.service,
            packingPrice: result.invoice.packing,
            discountPrice: result.invoice.discount,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
        this.setState({ invoiceLoading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ invoiceLoading: false });
      });
  }

  updateWindowDimensions() {
    try {
      this.setState({ windowWidth: window.innerWidth }, () => {
        if (window.innerWidth >= 600) this.setState({ showSearchField: false });
      });
    } catch (error) {}
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    window.removeEventListener("mousedown", this.handleClickOutside);
  }

  // componentDidMount() {

  // }

  // componentWillUnmount() {

  // }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    // console.log(event);
    // console.log(this.quantityRef);
    // console.log(this.keyboardContainer);
    // if (this.quantityRef) console.log(this.quantityRef.current);
    if (
      (this.keyboardContainer &&
        this.keyboardContainer.current &&
        this.quantityRef &&
        this.quantityRef.current &&
        !this.quantityRef.current.contains(event.target) &&
        !this.keyboardContainer.current.contains(event.target)) ||
      ((!this.keyboardContainer || !this.keyboardContainer.current) &&
        this.quantityRef &&
        this.quantityRef.current &&
        !this.quantityRef.current.contains(event.target))
    ) {
      // alert("You clicked outside of me!");
      let list = JSON.parse(JSON.stringify(this.state.shoppingList));
      list.forEach((element) => {
        element.editQuantity = false;
      });
      this.setState({ shoppingList: list }, () => {
        this.hideKeyboard();
      });
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("mousedown", this.handleClickOutside);
    let data = {
      type: "getMenuWithBusinessCode",
      languageId: this.state.defaultLanguage,
      businessCode: this.props.businessCode,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "getMenu", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getMenu:", result);
        if (result.status === 200) {
          if (result.result.length > 0) {
            let menu = JSON.parse(JSON.stringify(result.result));
            menu.forEach((element) => {
              let catname = "";
              element.nameObj.forEach((element1) => {
                if (element1.languageId === 1) {
                  catname = element1.name;
                }
              });

              if (catname === "") {
                element.nameObj.forEach((element1) => {
                  if (element1.languageId === this.state.defaultLanguage) {
                    catname = element1.name;
                  }
                });
              }

              if (catname === "") {
                element.nameObj.forEach((element1) => {
                  if (catname === "" && element1.name !== "") {
                    catname = element1.name;
                  }
                });
              }
              element.name = catname;

              element.items.forEach((element2) => {
                let itemname = "";
                let itemdescr = "";

                element2.nameObj.forEach((element3) => {
                  if (element3.languageId === 1) {
                    itemname = element3.name;
                  }
                });
                if (itemname === "") {
                  element2.nameObj.forEach((element3) => {
                    if (element3.languageId === this.state.defaultLanguage) {
                      itemname = element3.name;
                    }
                  });
                }

                if (itemname === "") {
                  element2.nameObj.forEach((element3) => {
                    if (itemname === "" && element3.name !== "") {
                      itemname = element3.name;
                    }
                  });
                }
                element2.descrObj.forEach((element3) => {
                  if (element3.languageId === 1) {
                    itemdescr = element3.descr;
                  }
                });
                if (itemdescr === "") {
                  element2.descrObj.forEach((element3) => {
                    if (element3.languageId === this.state.defaultLanguage) {
                      itemdescr = element3.descr;
                    }
                  });
                }
                if (itemdescr === "") {
                  element2.descrObj.forEach((element3) => {
                    if (itemdescr === "" && element3.descr !== "") {
                      itemdescr = element3.descr;
                    }
                  });
                }
                element2.descr = itemdescr;

                element2.name = itemname;
                element2.foodName = itemname;
              });
            });

            this.setState({ Cats: menu, catActiveIndex: -1 }, () => {
              this.categoryClick(0, menu[0].id);
              this.getTables();
              if (this.state.currentOrder && this.state.currentOrder.length > 0)
                this.invoiceCalculator();
            });
          }
        } else if (result.status === 401) {
          LogoutFunction();
        }

        // this.setState({ loading: false });
      })
      .catch((err) => {
        console.log(err);
        // this.setState({ loading: false });
      });
  }

  getTables() {
    let data = {
      businessId: this.props.resID,
      businessCode: this.props.businessCode,
    };
    console.log(data);
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findAllStation", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getTables", result);
        if (result.status === 200) {
          this.setState(
            {
              tablesList: result.result.reverse(),
              loading: false,
            },
            () => {
              if (result.result.length === 1) {
                this.setState({
                  selectedTableId: result.result[0].id,
                  selectedTableName: result.result[0].name,
                });
              }
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  categoryClick(i, id) {
    this.setState({ catActiveIndex: i, searchValue: "" });
    this.updateMenu(id);
  }

  updateMenu(id) {
    this.state.Cats.forEach((element) => {
      if (element.id === id) {
        let foods = element.items;
        this.setState({ Foods: foods });
      }
    });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  createUpdateOrder() {
    let temp;
    let newOrder = false;
    let newItems = [];
    let finalEditedItem = [];

    if (this.state.currentOrder && this.state.currentOrder.length > 0) {
      temp = JSON.parse(JSON.stringify(this.state.currentOrder));
      temp.forEach((element) => {
        let found = false;
        this.state.shoppingList.forEach((element1) => {
          let idid = element1.categoryId ? element1.id : element1.foodId;
          if (element.foodId === idid) {
            found = true;
            if (element.quantity !== element1.quantity) {
              element.action = "edit";
              element.quantity = element1.quantity;
            }
          }
        });

        if (!found) element.action = "delete";
      });

      this.state.shoppingList.forEach((element) => {
        let found = false;
        let idid = element.categoryId ? element.id : element.foodId;
        temp.forEach((element1) => {
          if (idid === element1.foodId) found = true;
        });

        if (!found) {
          let t = element;
          t.action = "add";
          temp.push(t);
        }
      });

      temp = temp.filter(
        (item) =>
          item.action &&
          (item.action === "add" ||
            item.action === "edit" ||
            item.action === "delete")
      );

      let tt = [];
      temp.forEach((element) => {
        tt.push({
          foodId: element.action !== "add" ? element.foodId : element.id,
          price: element.price,
          quantity: element.quantity,
          itemId: element.action !== "add" ? element.itemId : null,
          action: element.action,
        });
      });

      console.log("first Temp:", temp);

      temp = tt;
      newOrder = false;
    } else {
      newOrder = true;
      this.state.shoppingList.forEach((element) => {
        newItems.push({
          quantity: element.quantity,
          foodId: element.id,
          price: element.price,
        });
      });
    }

    let data;
    if (newOrder) {
      let newmobile = this.state.mobileValue;
      if (newmobile && newmobile.toString().startsWith("0")) {
        newmobile = newmobile.substring(1);
        newmobile = "+98" + newmobile;
      }
      data = {
        orderStationId: this.state.selectedTableId,
        status: 1,
        businessId: this.props.resID,
        items: newItems,
        discount: 0,
        discountCode: null,
        customerMobile: newmobile ? newmobile : null,
        descr: this.state.desValue,
        languageId: this.state.defaultLanguage,
        numberOfGuests: this.state.numberOfGuests,
        settlementType: this.state.settlementType,
      };
    } else {
      data = {
        orderId: this.state.currentOrderId,
        orderStationId: this.state.selectedTableId,
        businessId: this.props.resID,
        discount: 0,
        descr: this.state.desValue,
        languageId: this.state.defaultLanguage,
        editedItems: temp,
        numberOfGuests: this.state.numberOfGuests,
        settlementType: this.state.settlementType,
      };
    }

    data = Object.assign(data, Authorization());
    data = Object.assign(data, { businessCode: this.props.businessCode });
    console.log(data);
    // return;
    // if (!newOrder)
    //   data = Object.assign(data, { id: this.state.currentOrderId, });

    // if (this.state.ModalGetCode) this.setState({ verifyLoading: true });
    // else this.setState({ doneLoading: true });
    this.setState({ doneLoading: true });
    fetch(BaseUrl + (newOrder ? "createNewOrder" : "updateOrder"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          if (this.state.currentOrder && this.state.currentOrder.length > 0) {
            toast.success(
              "سفارش " + this.state.selectedTableName + " با موفقیت ویرایش شد",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true,
                autoClose: 6000,
                toastClassName: "toast",
              }
            );
            this.findOneOrder(this.state.currentOrderId);
          } else {
            this.findOneOrder(result.orderId);
            this.sendOrderToPrinter(result.orderId, false);
            toast.success(
              "سفارش " + this.state.selectedTableName + " با موفقیت ثبت شد",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true,
                autoClose: 6000,
                toastClassName: "toast",
              }
            );
          }

          if (this.props.currentorderStationId !== this.state.selectedTableId)
            this.props.updateProps(
              "currentorderStationId",
              this.state.selectedTableId
            );
          if (this.props.currentOrderDes !== this.state.desValue)
            this.props.updateProps("currentOrderDes", this.state.desValue);

          console.log(
            this.props.numberOfGuests + "_____" + this.state.numberOfGuests
          );
          if (this.props.numberOfGuests !== this.state.numberOfGuests)
            this.props.updateProps(
              "numberOfGuests",
              result.result.numberOfGuests
            );

          if (this.props.settlementType !== this.state.settlementType)
            this.props.updateProps(
              "settlementType",
              result.result.settlementType
            );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }

        this.setState({ doneLoading: false, verifyLoading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ doneLoading: false, verifyLoading: false });
      });
  }

  findOneOrder(id) {
    let data = {
      orderId: id,
      businessCode: this.props.businessCode,
      languageId: this.state.defaultLanguage,
      // version: 2,
    };
    console.log(data);
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findOneOrder", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("findOneOrder", result);
        if (result.status === 200) {
          this.setState({
            currentOrderId: result.result.id,
            currentOrderStatus: result.result.status,
          });
          this.props.updateProps("currentOrderId", result.result.id);
          this.props.updateProps(
            "numberOfGuests",
            result.result.numberOfGuests
          );
          this.props.updateProps(
            "settlementType",
            result.result.settlementType
          );
          let temp = [...result.result.items];

          temp = temp.filter((item) => item.isDeleted === 0);

          this.setState({ currentOrder: temp }, () => {
            temp.forEach((element) => {
              element.name = element.foodName;
              element.itemId = element.id;
              element.id = element.foodId;
            });
            this.setState({ shoppingList: temp });
            this.props.updateProps("currentOrder", temp);
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  DeleteChangesConfirm() {
    this.setState(
      {
        shoppingList: this.state.currentOrder,
        ModalDeleteChanges: false,
        totalPrice: 0,
        sumItem: 0,
        extrasPrice: 0,
        servicePrice: 0,
        deliveryPrice: 0,
        packingPrice: 0,
        discountPrice: 0,
        taxPrice: 0,
      },
      () => {
        this.invoiceCalculator();
      }
    );
  }

  showKeyboard(target, type) {
    this.setState(
      { keyboard: true, keyboardOpacity: 0, currentInputTarget: target },
      () => {
        this.setState({ keyboardLayoutName: type }, () => {
          this.calculateKeyboardPos(target);
        });
      }
    );
  }

  hideKeyboard() {
    this.setState({
      keyboard: false,
      keyboardOpacity: 0,
      currentInputTarget: null,
    });
  }

  calculateKeyboardPos(target) {
    setTimeout(() => {
      let targetInput = target.current.getBoundingClientRect();
      let keyboardInfo = this.keyboardContainer.current.getBoundingClientRect();
      let left =
        targetInput.left + targetInput.width / 2 - keyboardInfo.width / 2;
      if (left + keyboardInfo.width > window.innerWidth)
        left = window.innerWidth - keyboardInfo.width;
      let top = targetInput.top + targetInput.height + 2;
      if (top + keyboardInfo.height + 2 > window.innerHeight)
        top = targetInput.top - 2;
      this.setState(
        {
          keyboardPositionLeft: left,
          keyboardPositionTop: top,
          keyboardOpacity: 1,
        },
        () => {
          console.log(target.current.value);
          this.keyboardObject.current.setInput(target.current.value);
          this.keyboardObject.current.getCaretPositionEnd();
        }
      );
    }, 20);
  }

  onConfirmQuantity() {
    if (
      !this.quantityRef.current.value.trim() ||
      this.quantityRef.current.value.length === 0 ||
      Number(this.quantityRef.current.value.trim()) === 0 ||
      isNaN(this.quantityRef.current.value)
    ) {
      toast.error("تعداد محصول باید عدد باشد", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 6000,
        toastClassName: "toast",
      });
      return;
    }
    let list = JSON.parse(JSON.stringify(this.state.shoppingList));

    list.forEach((element) => {
      if (element.id === this.state.currentItemQuantitySelected) {
        element.quantity = this.quantityRef.current.value;
        element.editQuantity = false;
      }
    });

    this.setState({ shoppingList: list });
    this.hideKeyboard();
  }

  deleteOrder() {
    let data = {
      orderId: this.state.currentOrderId,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "deleteOrder", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          toast.success(
            "سفارش " + this.state.selectedTableName + " با موفقیت ابطال شد",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 6000,
              toastClassName: "toast",
            }
          );
          this.setState(
            {
              ModalInfoShow: false,
              shoppingList: [],
              selectedTableId: null,
              selectedTableName: "",
              desValue: "",
              numberOfGuests: null,
              settlementType: 5,
              // catActiveIndex: -1,
              Foods: [],
              totalPrice: 0,
              sumItem: 0,
              extrasPrice: 0,
              servicePrice: 0,
              deliveryPrice: 0,
              packingPrice: 0,
              discountPrice: 0,
              taxPrice: 0,
              mobileValue: "",
              currentOrderId: null,
              currentOrder: [],
              ModalDeleteOrder: false,
            },
            () => {
              this.categoryClick(0, this.state.Cats[0].id);
              let a = window.location.href.split("/");
              if (a[a.length - 1].toString().toLowerCase().trim() !== "cashier")
                this.props.getOrders();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  changeOrderStatus(id) {
    let data = {
      orderId: id,
      status: 3,
      businessCode: this.props.businessCode,
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "changeOrderStatus", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          this.setState(
            {
              ModalInfoShow: false,
              shoppingList: [],
              selectedTableId: null,
              selectedTableName: "",
              desValue: "",
              numberOfGuests: null,
              settlementType: 5,
              // catActiveIndex: -1,
              Foods: [],
              totalPrice: 0,
              sumItem: 0,
              extrasPrice: 0,
              servicePrice: 0,
              deliveryPrice: 0,
              packingPrice: 0,
              discountPrice: 0,
              taxPrice: 0,
              mobileValue: "",
              currentOrderId: null,
              currentOrder: [],
            },
            () => {
              this.categoryClick(0, this.state.Cats[0].id);
              // if (this.props.currentOrder && this.props.currentOrder.length > 0)
              let a = window.location.href.split("/");
              if (a[a.length - 1].toString().toLowerCase().trim() !== "cashier")
                this.props.getOrders();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  isEditedWithoutSaving() {
    if (this.props.currentOrderDes !== this.state.desValue) return true;
    if (Number(this.props.numberOfGuests) !== Number(this.state.numberOfGuests))
      return true;
    if (this.props.settlementType !== this.state.settlementType) return true;
    if (this.props.currentorderStationId !== this.state.selectedTableId)
      return true;
    let aa = JSON.stringify(this.state.currentOrder.sort());
    let bb = JSON.stringify(this.state.shoppingList.sort());
    if (aa !== bb) return true;
    else return false;
  }

  sendOrderToPrinter(orderId, notify) {
    let data = {
      businessCode: this.props.businessCode,
      orderId: Number(orderId),
      languageId: this.state.defaultLanguage,
      forCashier: 1,
      rePrint: 0,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "sendOrderToPrinter", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          if (notify)
            toast.success(
              "فاکتور سفارش " +
                this.state.selectedTableName +
                " با موفقیت ارسال شد",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true,
                autoClose: 6000,
                toastClassName: "toast",
              }
            );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  sendOrderToPrinter2(orderId) {
    let data = {
      businessCode: this.props.businessCode,
      orderId: Number(orderId),
      languageId: this.state.defaultLanguage,
      forCashier: 0,
      rePrint: 1,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "sendOrderToPrinter", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  sendCustomPrintOnCashier() {
    // console.log("shoppingList: ", this.state.shoppingList);
    // console.log("currentOrderInfo: ", this.state.currentOrderInfo);
    let ci = this.state.currentOrderInfo;
    ci.items = this.state.shoppingList;
    ci.packing = this.state.packingPrice;
    ci.discount = this.state.discountPrice;
    ci.service = this.state.servicePrice;
    ci.sum = Number(this.state.totalPrice);
    ci.sumItem = this.state.sumItem;
    ci.tax = this.state.taxPrice;

    let data = {
      businessCode: this.props.businessCode,
      printObj: ci,
    };

    console.log(data);
    // return;
    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "sendCustomPrintOnCashier", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ loading: false });
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  onSelectCheckout(e) {
    this.setState({ settlementType: e, ModalCheckout: false }, () => {
      if (this.state.SubmitAfterCheckout) {
        this.createUpdateOrder();
      }
    });
  }

  render() {
    if (!this.state.loading) {
      return (
        <div
          className="cashierMainContainer"
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            backgroundColor: "var(--gray1)",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            padding: "0px 10px",
            zIndex: "1",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "60px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0px 10px",
              position: "relative",
            }}
          >
            {((this.state.windowWidth < 600 && this.state.showSearchField) ||
              this.state.windowWidth >= 600) && (
              <div
                style={{
                  flex: "1",
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <Form.Control
                  className="inputStyleForm textAlignCenter"
                  placeholder="جستجو"
                  style={{ maxWidth: "300px", width: "100%", direction: "rtl" }}
                  autoComplete="off"
                  type="text"
                  name="searchValue"
                  onFocus={() => {
                    if (this.state.keyboardMode)
                      this.showKeyboard(this.searchRef, "default");
                  }}
                  onChange={(e) => {
                    this.setState({ searchValue: e.target.value });
                  }}
                  value={this.state.searchValue}
                  ref={this.searchRef}
                />
                {this.state.windowWidth < 600 && (
                  <div
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => {
                      this.setState({ showSearchField: false });
                    }}
                  >
                    <Icon
                      icon={baselineClose}
                      width="25"
                      height="25"
                      style={{ color: "var(--brown1)" }}
                    />
                  </div>
                )}

                <div
                  style={{ cursor: "pointer", userSelect: "none" }}
                  // onClick={() => {
                  //   this.setState({ showSearchField: false });
                  // }}
                >
                  <Icon
                    icon={
                      this.state.keyboardMode
                        ? baselineKeyboard
                        : outlineKeyboard
                    }
                    width="25"
                    height="25"
                    style={{
                      color: this.state.keyboardMode
                        ? "var(--brown1)"
                        : "var(--gray3)",
                    }}
                    onClick={() => {
                      this.setState(
                        { keyboardMode: !this.state.keyboardMode },
                        () => {
                          this.hideKeyboard();
                        }
                      );
                    }}
                  />
                </div>
              </div>
            )}

            {this.state.windowWidth < 600 && !this.state.showSearchField && (
              <div
                style={{
                  flex: "1",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  style={{ cursor: "pointer", userSelect: "none" }}
                  onClick={() => {
                    this.setState({ showSearchField: true }, () => {
                      this.searchRef.current.focus();
                    });
                  }}
                >
                  <Icon
                    icon={baselineSearch}
                    width="25"
                    height="25"
                    style={{ color: "var(--brown1)" }}
                  />
                </div>
              </div>
            )}

            {!this.state.showSearchField && this.props.userFullName && (
              <div
                style={{
                  flex: "1",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    backgroundColor: "#FFFFFF80",
                    border: "1px solid #00000040",
                    borderRadius: "15px",
                    padding: "8px 20px",
                    fontSize: "16px",
                    fontWeight: "700",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <Icon
                    icon={roundPerson}
                    width="25"
                    height="25"
                    style={{ color: "var(--brown1)" }}
                  />
                  {this.props.userFullName}
                </div>
              </div>
            )}
            <CashierDateTime />
            {/* <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                flex: "1",
                gap: "16px",
                fontSize: "16px",
                fontWeight: "400",
              }}
            >
              <div>{this.state.dateValue}</div>
              <div>{this.state.timeValue}</div>
            </div> */}
          </div>
          <div className="cashierMiddleContainer">
            <div
              style={{
                display: "flex",
                flex: "1",
                justifyContent:
                  this.state.Foods.length > 0 ? "flex-start" : "center",
                alignItems:
                  this.state.Foods.length > 0 ? "flex-start" : "center",
                position: "relative",
                border: "1px solid var(--brown1)",
                borderRadius: "15px",
                padding: "5px",
                flexDirection: "column",
                gap: "5px",
              }}
              className="foodsContainerParent"
            >
              {this.state.Foods.length === 0 && (
                <div style={{ color: "var(--black2)", fontSize: "16px" }}>
                  لطفاً یک دسته را انتخاب کنید
                </div>
              )}
              <div
                style={{
                  flex: "1",
                  backgroundColor: "#4D4D4D",
                  padding: "10px",
                  textAlign: "center",
                  color: "white",
                  maxHeight: "45px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "10px",
                  width:
                    this.state.Foods.length < 1 ? "calc(100% - 10px)" : "100%",
                  // fontSize: "20px",
                  fontWeight: "700",
                  position:
                    this.state.Foods.length < 1 ? "absolute" : "relative",
                  top: this.state.Foods.length < 1 ? "5px" : "0",
                  left: this.state.Foods.length < 1 ? "5px" : "0",
                }}
              >
                محصولات دسته انتخابی
              </div>
              {this.state.Foods.length > 0 && (
                <ScrollContainer
                  hideScrollbars={false}
                  className="foodsContainer"
                >
                  {this.state.Foods.map((item, i) => {
                    return (
                      <Button
                        key={i}
                        style={{
                          height: "100px",
                          // width: "205px",
                          width: "100%",
                          backgroundColor: "white",
                          borderRadius: "10px",
                        }}
                        onClick={() => {
                          let list = JSON.parse(
                            JSON.stringify(this.state.shoppingList)
                          );

                          let found = false;
                          list.forEach((element) => {
                            if (element.id === item.id) {
                              found = true;
                              element.quantity = element.quantity + 1;
                            }
                          });

                          if (!found) {
                            let obj = item;
                            obj.quantity = 1;
                            list.push(obj);
                          }

                          this.setState({ shoppingList: list });
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            minHeight: "10px",
                            height: "100%",
                            // backgroundColor: "green",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flex: "1",
                            }}
                          >
                            <div
                              style={{
                                wordBreak: "break-word",
                                width: "100%",
                                // backgroundColor: "blue",
                                maxHeight: "60px",
                                overflow: "hidden",
                                fontSize: "16px",
                                // fontWeight: "700",
                                fontFamily: "SFUIDisplayBold",
                              }}
                            >
                              {item.name}
                            </div>
                          </div>
                          <div
                            style={{
                              minHeight: "1px",
                              backgroundColor: "#27272740",
                              width: "100%",
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              fontSize: "16px",
                              // fontWeight: "400",
                              color: "#1E1E1EB2",
                              flex: "1",
                              justifyContent: "center",
                              alignItems: "center",
                              // backgroundColor: "red",
                              minHeight: "10px",
                              width: "100%",
                              fontFamily: "SFUIDisplayThin",
                            }}
                          >
                            <NumericFormat
                              allowNegative={true}
                              value={item.price}
                              displayType={"text"}
                              thousandSeparator={true}
                            />
                            <div>&nbsp;{this.props.priceUnitValue}</div>
                          </div>
                        </div>
                      </Button>
                    );
                  })}
                </ScrollContainer>
              )}
              {this.state.totalPrice !== 0 && (
                <div
                  style={{
                    // width: "calc(100% - 10px)",
                    width: "100%",
                    // position: "absolute",
                    // bottom: "5px",
                    // right: "5px",
                    display: "flex",
                    flexDirection: "row",
                    border: "1px solid var(--brown1)",
                    borderRadius: "10px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "20px",
                    fontFamily: "SFUIDisplayBold",
                    padding: "10px",
                  }}
                >
                  <div>مبلغ قابل پرداخت:</div>
                  {!this.state.invoiceLoading && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        minWidth: "120px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <NumericFormat
                        allowNegative={true}
                        value={this.state.totalPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                      <div>&nbsp;{this.props.priceUnitValue}</div>
                    </div>
                  )}
                  {this.state.invoiceLoading && (
                    <div>
                      <ImpulseSpinner
                        size={24}
                        frontColor="var(--black1)"
                        backColor="var(--gray1)"
                        loading={true}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
            {/* <div
              style={{
                width: "100vw",
                minHeight: "1px",
                backgroundColor: "red",
                position: "fixed",
                left: "0",
                top: "110px",
                zIndex: "10",
              }}
            /> */}
            <ScrollContainer
              hideScrollbars={false}
              style={{
                overflowX: "auto",
                // padding: "0px 5px",
                display: "flex",
                gap: "5px",
              }}
              className="catsContainer"
            >
              <div
                style={{
                  // flex: "1",
                  backgroundColor: "#4D4D4D",
                  padding: "10px",
                  textAlign: "center",
                  color: "white",
                  // maxHeight: "50px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "10px",
                  width: "100%",
                  // fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                دسته بندی
              </div>
              {this.state.Cats.map((item, index) =>
                item.isEnable ? (
                  <div
                    key={index}
                    onClick={this.categoryClick.bind(this, index, item.id)}
                  >
                    <div
                      style={{
                        minWidth: "100px",
                        width: "100%",
                        minHeight: "80px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        userSelect: "none",
                        border: "1px solid var(--brown1)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        backgroundColor:
                          this.state.catActiveIndex === index
                            ? "var(--brown1)"
                            : "transparent",
                        color:
                          this.state.catActiveIndex === index
                            ? "white"
                            : "black",
                        padding: "5px",
                      }}
                      // className="catButton"
                    >
                      {item.name}
                    </div>
                  </div>
                ) : null
              )}
            </ScrollContainer>
            <div
              style={{
                flex: "1",
                // height: "fit-content",
                // overflowY: "auto",
                height: "calc(100vh - 70px)",
                border: "1px solid var(--brown1)",
                borderRadius: "15px",
                display: "flex",
                flexDirection: "column",
                padding: "5px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: "1",
                  // gap: "10px",
                  // padding: "10px",
                  justifyContent: this.state.shoppingList.length
                    ? "flex-start"
                    : "center",
                  alignItems: "center",
                  minHeight: "10px",
                  position: "relative",
                }}
              >
                {this.state.shoppingList.length === 0 && (
                  <div
                    style={{
                      color: "var(--black2)",
                      minHeight: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    سبد خرید خالی است
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                    backgroundColor: "#4D4D4D",
                    padding: "10px",
                    textAlign: "center",
                    color: "white",
                    maxHeight: "45px",
                    borderRadius: "10px",
                    width: "100%",
                    // fontSize: "20px",
                    fontWeight: "700",
                    position:
                      this.state.shoppingList.length < 1
                        ? "absolute"
                        : "relative",
                    top: "0",
                    left: "0",
                    minHeight: "45px",
                  }}
                  className="shoppingCardContainerParent"
                >
                  <div>
                    {this.state.currentOrderId && (
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        شماره فاکتور:{this.state.currentOrderId}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      position:
                        this.state.shoppingList.length < 1
                          ? "relative"
                          : "absolute",
                      left:
                        this.state.shoppingList.length < 1 ? "unset" : "50%",
                      top: this.state.shoppingList.length < 1 ? "unset" : "50%",
                      transform:
                        this.state.shoppingList.length < 1
                          ? "unset"
                          : "translate(-50%, -50%)",
                    }}
                  >
                    سبد خرید
                  </div>
                  <div>
                    {this.props.customerName && (
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        نام مشتری:{this.props.customerName}
                      </div>
                    )}
                  </div>
                </div>
                {this.state.shoppingList.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      padding: "10px",
                      // backgroundColor: "red",
                      display: "flex",
                      flexDirection: "column",
                      borderBottom: "2px solid var(--black1)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <CustomButton
                        ico={baselineClose}
                        width="fit-content"
                        fontSize="inherit"
                        width="30px"
                        onClick={() => {
                          this.setState({ ModalDeleteChanges: true });
                        }}
                      />
                      {this.state.currentOrder &&
                        this.state.currentOrder.length > 0 && (
                          <CustomButton
                            title={
                              this.state.windowWidth < 768 ? null : "ابطال"
                            }
                            ico={
                              this.state.windowWidth < 768
                                ? "ic:outline-delete"
                                : null
                            }
                            width="fit-content"
                            fontSize="inherit"
                            onClick={() => {
                              this.setState({ ModalDeleteOrder: true });
                            }}
                          />
                        )}
                      <div style={{ flex: "1" }} />
                      <CustomButton
                        title={this.state.windowWidth < 768 ? null : "توضیحات"}
                        ico={
                          this.state.windowWidth < 768
                            ? "basil:comment-outline"
                            : null
                        }
                        width="fit-content"
                        onClick={() => {
                          this.setState({ ModalDesShow: true }, () => {
                            this.desRef.current.value = this.state.desValue;
                            this.desRef.current.focus();
                          });
                        }}
                      />
                      <CustomButton
                        title={this.state.windowWidth < 768 ? null : "میهمان"}
                        ico={
                          this.state.windowWidth < 768
                            ? "ic:round-person-outline"
                            : null
                        }
                        width="fit-content"
                        onClick={() => {
                          this.setState({ ModalGuestsShow: true }, () => {
                            this.guestsRef.current.value =
                              this.state.numberOfGuests;
                            this.guestsRef.current.focus();
                          });
                        }}
                      />
                      {(!this.state.currentOrder ||
                        this.state.currentOrder.length < 1) && (
                        <CustomButton
                          title={
                            this.state.windowWidth < 768
                              ? null
                              : this.state.mobileValue
                              ? this.state.mobileValue
                              : "اشتراک"
                          }
                          // ico={
                          //   this.state.windowWidth < 768
                          //     ? "clarity:mobile-line"
                          //     : null
                          // }

                          ico={
                            this.state.windowWidth < 768 &&
                            this.state.mobileValue
                              ? "clarity:mobile-solid"
                              : this.state.windowWidth < 768 &&
                                !this.state.mobileValue
                              ? "clarity:mobile-line"
                              : null
                          }
                          width="fit-content"
                          onClick={() => {
                            if (
                              !this.state.currentOrder ||
                              this.state.currentOrder.length < 1
                            ) {
                              this.setState({ ModalInfoShow: true }, () => {
                                this.mobileRef.current.focus();
                              });
                            }
                          }}
                        />
                      )}
                      <CustomButton
                        // title={this.state.windowWidth < 768 ? null:
                        //   this.state.selectedTableName
                        //     ? this.state.selectedTableName
                        //     : "انتخاب ایستگاه"
                        // }
                        title={
                          this.state.windowWidth < 768
                            ? null
                            : this.state.selectedTableName
                            ? this.state.selectedTableName
                            : "ایستگاه"
                        }
                        ico={
                          this.state.windowWidth < 768 &&
                          this.state.selectedTableName
                            ? "material-symbols:table-bar-rounded"
                            : this.state.windowWidth < 768 &&
                              !this.state.selectedTableName
                            ? "material-symbols:table-bar-outline-sharp"
                            : null
                        }
                        width="fit-content"
                        onClick={() => {
                          this.setState({ ModalTableShow: true });
                        }}
                      />
                    </div>
                  </div>
                )}
                {this.state.shoppingList.length > 0 && (
                  <ScrollContainer
                    hideScrollbars={false}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flex: "1",
                      gap: "10px",
                      width: "100%",
                      overflowY: "auto",
                      padding: "10px",
                      minHeight: "300px",
                    }}
                    className="shoppingCardContainer"
                  >
                    {this.state.shoppingList.map((item, i) => {
                      if (this.state.windowWidth < 540) {
                        return (
                          <div
                            key={i}
                            style={{
                              gap: "15px",
                              width: "100%",
                              // minHeight: "50px",
                              borderRadius: "10px",
                              backgroundColor: "white",
                              // minHeight: "60px",
                              display: "flex",
                              flexDirection: "column",
                              padding: "5px 10px",
                              color: "var(--black1)",
                              alignItems: "flex-start",
                              fontSize: "14px",
                            }}
                            className="shoppingCardItem"
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                gap: "10px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "flex-start",
                                  justifyContent: "flex-start",
                                  // backgroundColor: "red",
                                  // gap: "5px",
                                }}
                              >
                                <div
                                  className="shoppingCardItemButton"
                                  style={{
                                    color: "var(--black1)",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",

                                    // paddingTop: "2px",
                                  }}
                                >
                                  {i + 1}
                                  <Icon
                                    icon="mdi:dot"
                                    style={{ color: "var(--black1)" }}
                                  />
                                </div>
                                <div
                                  style={{
                                    textAlign: "right",
                                    wordBreak: "break-all",
                                  }}
                                >
                                  {item.name}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <NumericFormat
                                  allowNegative={true}
                                  value={
                                    item.quantity
                                      ? item.quantity * item.price
                                      : item.price
                                  }
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                                <div>&nbsp;{this.props.priceUnitValue}</div>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  cursor: "pointer",
                                  userSelect: "none",
                                  backgroundColor: "var(--red1)",
                                }}
                                onClick={() => {
                                  let list = JSON.parse(
                                    JSON.stringify(this.state.shoppingList)
                                  );
                                  list.splice(i, 1);
                                  this.setState({ shoppingList: list });
                                }}
                              >
                                <Icon
                                  icon={deleteIcon}
                                  width="20"
                                  height="20"
                                  style={{ color: "white" }}
                                />
                              </div>
                              <div
                                style={{
                                  // border: "1px solid var(--black1)",
                                  // borderWidth: "0px 1px 0px 1px",
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  height: "100%",
                                  // padding: "0px 10px",
                                }}
                              >
                                <div
                                  className="plusminus1"
                                  onClick={() => {
                                    let list = JSON.parse(
                                      JSON.stringify(this.state.shoppingList)
                                    );

                                    list.forEach((element) => {
                                      if (element.id === item.id) {
                                        element.quantity =
                                          Number(element.quantity) + 1;
                                      }
                                    });

                                    this.setState({ shoppingList: list });
                                  }}
                                >
                                  <Icon
                                    icon={baselinePlus}
                                    width="20"
                                    height="20"
                                    style={{ color: "white" }}
                                  />
                                </div>
                                {!item.editQuantity && (
                                  <div
                                    style={{
                                      minWidth: "40px",
                                      // backgroundColor: "red",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "100%",
                                    }}
                                    onClick={() => {
                                      let list = JSON.parse(
                                        JSON.stringify(this.state.shoppingList)
                                      );
                                      let q = 0;
                                      list.forEach((element) => {
                                        if (element.id === item.id) {
                                          element.editQuantity = true;
                                          q = element.quantity;
                                        } else {
                                          element.editQuantity = false;
                                        }
                                      });

                                      this.setState(
                                        { shoppingList: list },
                                        () => {
                                          this.quantityRef.current.value = q;
                                          this.quantityRef.current.focus();
                                        }
                                      );
                                    }}
                                  >
                                    {item.quantity}
                                  </div>
                                )}

                                {item.editQuantity && (
                                  <Form.Control
                                    ref={this.quantityRef}
                                    maxLength="3"
                                    className="inputStyleForm textAlignCenter zeroPadding"
                                    style={{
                                      width: "40px",
                                      border: "none",
                                      direction: "ltr",
                                      margin: "0px 5px",
                                    }}
                                    type="text"
                                    onFocus={() => {
                                      this.setState(
                                        {
                                          currentItemQuantitySelected: item.id,
                                        },
                                        () => {
                                          if (
                                            this.state.keyboardMode &&
                                            this.quantityRef &&
                                            this.quantityRef.current
                                          ) {
                                            this.showKeyboard(
                                              this.quantityRef,
                                              "num"
                                            );
                                          }
                                        }
                                      );
                                    }}
                                    onKeyPress={(target) => {
                                      if (target.charCode === 13) {
                                        this.onConfirmQuantity();
                                      }
                                    }}
                                  />
                                )}

                                <div
                                  className="plusminus1"
                                  onClick={() => {
                                    let list = JSON.parse(
                                      JSON.stringify(this.state.shoppingList)
                                    );

                                    let found = false;
                                    list.forEach((element) => {
                                      if (element.id === item.id) {
                                        if (element.quantity > 1)
                                          element.quantity =
                                            element.quantity - 1;
                                      }
                                    });

                                    this.setState({ shoppingList: list });
                                  }}
                                >
                                  <Icon
                                    icon={baselineMinus}
                                    width="20"
                                    height="20"
                                    style={{ color: "white" }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        return (
                          <div
                            key={i}
                            style={{
                              gap: "10px",
                              width: "100%",
                              minHeight: "50px",
                              borderRadius: "10px",
                              backgroundColor: "white",
                              minHeight: "60px",
                              display: "flex",
                              flexDirection: "row",
                              padding: "5px 10px",
                              color: "var(--black1)",
                              alignItems: "center",
                              fontSize: "18px",
                            }}
                            className="shoppingCardItem"
                          >
                            <div
                              style={{
                                color: "var(--black1)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "2px",
                              }}
                              className="shoppingCardItemButton"
                            >
                              {i + 1}
                            </div>
                            <div
                              style={{
                                minWidth: "1px",
                                backgroundColor: "var(--black1)",
                                height: "100%",
                              }}
                            />
                            <div style={{ flex: "1.5", textAlign: "right" }}>
                              {item.name}
                            </div>
                            <div
                              style={{
                                border: "1px solid var(--black1)",
                                borderWidth: "0px 1px 0px 1px",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                height: "100%",
                                padding: "0px 10px",
                              }}
                            >
                              <div
                                className="plusminus1"
                                onClick={() => {
                                  let list = JSON.parse(
                                    JSON.stringify(this.state.shoppingList)
                                  );

                                  list.forEach((element) => {
                                    if (element.id === item.id) {
                                      element.quantity =
                                        Number(element.quantity) + 1;
                                    }
                                  });

                                  this.setState({ shoppingList: list });
                                }}
                              >
                                <Icon
                                  icon={baselinePlus}
                                  width="20"
                                  height="20"
                                  style={{ color: "white" }}
                                />
                              </div>
                              {!item.editQuantity && (
                                <div
                                  style={{
                                    minWidth: "50px",
                                    // backgroundColor: "red",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                  }}
                                  onClick={() => {
                                    let list = JSON.parse(
                                      JSON.stringify(this.state.shoppingList)
                                    );
                                    let q = 0;
                                    list.forEach((element) => {
                                      if (element.id === item.id) {
                                        element.editQuantity = true;
                                        q = element.quantity;
                                      } else {
                                        element.editQuantity = false;
                                      }
                                    });

                                    this.setState(
                                      { shoppingList: list },
                                      () => {
                                        this.quantityRef.current.value = q;
                                        this.quantityRef.current.focus();
                                      }
                                    );
                                  }}
                                >
                                  {item.quantity}
                                </div>
                              )}

                              {item.editQuantity && (
                                <Form.Control
                                  ref={this.quantityRef}
                                  maxLength="3"
                                  className="inputStyleForm textAlignCenter zeroPadding"
                                  style={{
                                    width: "40px",
                                    border: "none",
                                    direction: "ltr",
                                    margin: "0px 5px",
                                  }}
                                  type="text"
                                  onFocus={() => {
                                    this.setState(
                                      { currentItemQuantitySelected: item.id },
                                      () => {
                                        if (
                                          this.state.keyboardMode &&
                                          this.quantityRef &&
                                          this.quantityRef.current
                                        ) {
                                          this.showKeyboard(
                                            this.quantityRef,
                                            "num"
                                          );
                                        }
                                      }
                                    );
                                  }}
                                  onKeyPress={(target) => {
                                    if (target.charCode === 13) {
                                      this.onConfirmQuantity();
                                    }
                                  }}
                                />
                              )}

                              <div
                                className="plusminus1"
                                onClick={() => {
                                  let list = JSON.parse(
                                    JSON.stringify(this.state.shoppingList)
                                  );

                                  let found = false;
                                  list.forEach((element) => {
                                    if (element.id === item.id) {
                                      if (element.quantity > 1)
                                        element.quantity = element.quantity - 1;
                                    }
                                  });

                                  this.setState({ shoppingList: list });
                                }}
                              >
                                <Icon
                                  icon={baselineMinus}
                                  width="20"
                                  height="20"
                                  style={{ color: "white" }}
                                />
                              </div>
                            </div>
                            {/* <div style={{ flex: "0.2" }} /> */}

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                // backgroundColor: "red",
                                minWidth: "70px",
                                justifyContent: "center",
                                flex: "0.5",
                              }}
                            >
                              <NumericFormat
                                allowNegative={true}
                                value={
                                  item.quantity
                                    ? item.quantity * item.price
                                    : item.price
                                }
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                              <div>&nbsp;{this.props.priceUnitValue}</div>
                            </div>
                            <div
                              style={{
                                minWidth: "1px",
                                backgroundColor: "var(--black1)",
                                height: "100%",
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "25px",
                                height: "25px",
                                // border: "2px solid white",
                                borderRadius: "50%",
                                cursor: "pointer",
                                userSelect: "none",
                                backgroundColor: "var(--red1)",
                              }}
                              onClick={() => {
                                let list = JSON.parse(
                                  JSON.stringify(this.state.shoppingList)
                                );
                                list.splice(i, 1);
                                this.setState({ shoppingList: list });
                              }}
                            >
                              <Icon
                                icon={deleteIcon}
                                width="20"
                                height="20"
                                style={{ color: "white" }}
                              />
                            </div>
                          </div>
                        );
                      }
                    })}
                  </ScrollContainer>
                )}
                {this.state.shoppingList.length > 0 &&
                  (this.state.totalPrice !== 0 ||
                    this.state.sumItem !== 0 ||
                    this.state.servicePrice !== 0 ||
                    this.state.packingPrice !== 0 ||
                    this.state.discountPrice !== 0 ||
                    this.state.taxPrice !== 0) && (
                    <div
                      style={{
                        padding: "15px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid var(--brown1)",
                        // borderWidth: "2px 0 0 0",
                        // boxShadow: "0px -1px 15px var(--black2)",
                        gap: "12px",
                        borderRadius: "10px",
                      }}
                    >
                      {this.state.sumItem !== 0 && (
                        <div className="factureResultRow boldFont">
                          <div>جمع فاکتور:</div>
                          {!this.state.invoiceLoading && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                minWidth: "120px",
                                justifyContent: "flex-end",
                              }}
                            >
                              <NumericFormat
                                allowNegative={true}
                                value={this.state.sumItem}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                              <div>&nbsp;{this.props.priceUnitValue}</div>
                            </div>
                          )}
                          {this.state.invoiceLoading && (
                            <div>
                              <ImpulseSpinner
                                size={24}
                                frontColor="var(--black1)"
                                backColor="var(--gray1)"
                                loading={true}
                              />
                            </div>
                          )}
                        </div>
                      )}

                      {this.state.discountPrice !== 0 && (
                        <div className="factureResultRow thinFont">
                          <div>تخفیف:</div>
                          {!this.state.invoiceLoading && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                minWidth: "120px",
                                justifyContent: "flex-end",
                              }}
                            >
                              <NumericFormat
                                allowNegative={true}
                                value={this.state.discountPrice}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                              <div>&nbsp;{this.props.priceUnitValue}</div>
                            </div>
                          )}
                          {this.state.invoiceLoading && (
                            <div>
                              <ImpulseSpinner
                                size={18}
                                frontColor="var(--black1)"
                                backColor="var(--gray1)"
                                loading={true}
                              />
                            </div>
                          )}
                        </div>
                      )}

                      {this.state.taxPrice !== 0 && (
                        <div className="factureResultRow thinFont">
                          <div>مالیات:</div>
                          {!this.state.invoiceLoading && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                minWidth: "120px",
                                justifyContent: "flex-end",
                              }}
                            >
                              <NumericFormat
                                allowNegative={true}
                                value={this.state.taxPrice}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                              <div>&nbsp;{this.props.priceUnitValue}</div>
                            </div>
                          )}
                          {this.state.invoiceLoading && (
                            <div>
                              <ImpulseSpinner
                                size={18}
                                frontColor="var(--black1)"
                                backColor="var(--gray1)"
                                loading={true}
                              />
                            </div>
                          )}
                        </div>
                      )}

                      {this.state.servicePrice !== 0 && (
                        <div className="factureResultRow thinFont">
                          <div>سرویس:</div>
                          {!this.state.invoiceLoading && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                minWidth: "120px",
                                justifyContent: "flex-end",
                              }}
                            >
                              <NumericFormat
                                allowNegative={true}
                                value={this.state.servicePrice}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                              <div>&nbsp;{this.props.priceUnitValue}</div>
                            </div>
                          )}
                          {this.state.invoiceLoading && (
                            <div>
                              <ImpulseSpinner
                                size={18}
                                frontColor="var(--black1)"
                                backColor="var(--gray1)"
                                loading={true}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      {this.state.packingPrice !== 0 && (
                        <div className="factureResultRow thinFont">
                          <div>بسته بندی:</div>
                          {!this.state.invoiceLoading && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                minWidth: "120px",
                                justifyContent: "flex-end",
                              }}
                            >
                              <NumericFormat
                                allowNegative={true}
                                value={this.state.packingPrice}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                              <div>&nbsp;{this.props.priceUnitValue}</div>
                            </div>
                          )}
                          {this.state.invoiceLoading && (
                            <div>
                              <ImpulseSpinner
                                size={18}
                                frontColor="var(--black1)"
                                backColor="var(--gray1)"
                                loading={true}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns:
                    this.state.currentOrderStatus === 1 &&
                    this.props.currentOrder &&
                    this.props.currentOrder.length > 0 &&
                    this.isEditedWithoutSaving()
                      ? "1fr 1fr 1fr 1fr 1fr"
                      : "1fr 1fr 1fr 1fr",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                {this.state.shoppingList.length > 0 &&
                  !this.state.currentOrderId && (
                    <CustomButton
                      title="ثبت سفارش"
                      minHeight="50px"
                      onClick={() => {
                        if (!this.state.selectedTableId) {
                          this.setState({ SubmitAfterTable: true }, () => {
                            this.setState({ ModalTableShow: true });
                          });
                          return;
                        }

                        if (this.state.settlementType === 5) {
                          this.setState({ SubmitAfterCheckout: true }, () => {
                            this.setState({ ModalCheckout: true });
                          });
                          return;
                        }
                        this.createUpdateOrder();

                        // if (this.state.selectedTableId && this.state.settlementType!==5) {
                        //   this.createUpdateOrder();
                        // } else if (!this.state.selectedTableId && this.state.settlementType!==5) {
                        //   this.setState({ SubmitAfterTable: true }, () => {
                        //     this.setState({ ModalTableShow: true });
                        //   });
                        // }else{
                        //   this.setState({ SubmitAfterCheckout: true }, () => {
                        //     this.setState({ ModalCheckout: true });
                        //   });
                        // }
                      }}
                    />
                  )}

                {this.state.shoppingList.length > 0 &&
                  this.state.currentOrderId &&
                  this.state.currentOrderStatus < 3 &&
                  this.props.currentOrder &&
                  this.props.currentOrder.length > 0 &&
                  this.isEditedWithoutSaving() && (
                    <CustomButton
                      title="ویرایش"
                      minHeight="50px"
                      onClick={() => {
                        this.createUpdateOrder();
                      }}
                    />
                  )}
                {/* {this.state.shoppingList.length > 0 &&
                  !this.state.currentOrderId && (
                    <CustomButton
                      title={
                        this.state.currentOrder &&
                        this.state.currentOrder.length > 0
                          ? "ویرایش سفارش"
                          : "ثبت سفارش"
                      }
                      minHeight="50px"
                      onClick={() => {
                        if (this.state.selectedTableId) {
                          if (
                            this.isEditedWithoutSaving() &&
                            this.state.currentOrder &&
                            this.state.currentOrder.length > 0
                          ) {
                            this.sendCustomPrintOnCashier();
                          } else if (this.isEditedWithoutSaving()) {
                            this.createUpdateOrder(false);
                          }
                        } else {
                          toast.error(
                            "برای ثبت سفارش باید یک ایستگاه انتخاب شود",
                            {
                              position: toast.POSITION.BOTTOM_RIGHT,
                              hideProgressBar: true,
                              autoClose: 6000,
                              toastClassName: "toast",
                            }
                          );
                        }
                      }}
                    />
                  )} */}

                {this.state.shoppingList.length > 0 &&
                  this.state.currentOrderId &&
                  this.state.currentOrderStatus !== 2 && (
                    <CustomButton
                      title={
                        this.isEditedWithoutSaving() &&
                        this.state.currentOrderStatus === 3
                          ? "ویرایش و چاپ"
                          : this.state.currentOrderStatus === 1
                          ? "تایید و چاپ"
                          : "چاپ سفارش"
                      }
                      backColor="var(--black1)"
                      minHeight="50px"
                      onClick={() => {
                        console.log(this.state.currentOrderStatus);
                        if (
                          this.state.currentOrderStatus &&
                          this.state.currentOrderStatus === 1
                        )
                          this.changeOrderStatus(this.state.currentOrderId);
                        else {
                          if (
                            this.isEditedWithoutSaving() &&
                            this.state.currentOrderStatus === 3
                          ) {
                            this.createUpdateOrder();
                          } else {
                            this.sendOrderToPrinter2(this.state.currentOrderId);
                          }
                        }
                      }}
                    />
                  )}

                {this.state.shoppingList.length > 0 &&
                  this.state.currentOrderId && (
                    <CustomButton
                      title="چاپ فاکتور"
                      backColor="var(--brown4)"
                      minHeight="50px"
                      onClick={() => {
                        if (this.state.currentOrderId) {
                          if (this.isEditedWithoutSaving()) {
                            this.sendCustomPrintOnCashier();
                          } else {
                            this.sendOrderToPrinter(
                              this.state.currentOrderId,
                              true
                            );
                          }
                        }
                      }}
                    />
                  )}

                {this.state.shoppingList.length > 0 &&
                  this.state.currentOrderId &&
                  this.state.currentOrderStatus !== 2 &&
                  this.state.settlementType !== 3 && (
                    <CustomButton
                      title="تسویه"
                      backColor="#0BC154"
                      minHeight="50px"
                      onClick={() => {
                        this.setState({ ModalCheckout: true });
                      }}
                    />
                  )}

                {(this.state.shoppingList.length < 1 ||
                  !this.state.currentOrderId ||
                  this.state.currentOrderStatus === 2) && (
                  <div
                    style={{
                      gridColumn:
                        this.state.currentOrderStatus === 1 &&
                        this.props.currentOrder &&
                        this.props.currentOrder.length > 0 &&
                        this.isEditedWithoutSaving()
                          ? "3/5"
                          : this.state.currentOrderStatus === 2 &&
                            this.props.currentOrder &&
                            this.props.currentOrder.length > 0 &&
                            this.isEditedWithoutSaving()
                          ? "3/4"
                          : "2/4",
                    }}
                  />
                )}
                <CustomButton
                  title="خروج"
                  minHeight="50px"
                  backColor="var(--red1)"
                  onClick={() => {
                    // if (
                    //   this.props.currentOrder &&
                    //   this.props.currentOrder.length > 0
                    // )
                    let a = window.location.href.split("/");
                    if (
                      a[a.length - 1].toString().toLowerCase().trim() !==
                      "cashier"
                    )
                      this.props.getOrders();
                    else {
                      this.props.backToDashboard();
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              height: "10px",
              display: "flex",
              flexDirection: "row",
              bottom: "0",
              left: "0",
            }}
            className="bottomBar"
          ></div>

          {this.state.keyboard && (
            <div
              style={{
                position: "fixed",
                top: this.state.keyboardPositionTop,
                left: this.state.keyboardPositionLeft,
                direction: "ltr",
                opacity: this.state.keyboardOpacity,
              }}
              ref={this.keyboardContainer}
            >
              <Keyboard
                // ref={this.keyboardObject}
                keyboardRef={(r) => (this.keyboardObject.current = r)}
                layout={{
                  default: [
                    "{close}",
                    "\u0636 \u0635 \u062b \u0642 \u0641 \u063a \u0639 \u0647 \u062e \u062d \u062c \u0686 {bksp}",
                    "\u0634 \u0633 \u06cc \u0628 \u0644 \u0627 \u062a \u0646 \u0645 \u06a9 \u06af {enter}",
                    "\u0638 \u0637 \u0632 \u0631 \u0630 \u062f \u0648 \u067e , . -",
                    "{num1} {space} {en}",
                  ],
                  en: [
                    "{close}",
                    "q w e r t y u i o p {bksp}",
                    "a s d f g h j k l {enter}",
                    "z x c v b n m , . -",
                    "{num2} {space} {fa}",
                  ],
                  num: [
                    "{confirm}",
                    "1 2 3",
                    "4 5 6",
                    "7 8 9",
                    "{close} 0 {bksp}",
                  ],
                  num1: ["{close}", "1 2 3", "4 5 6", "7 8 9", "{bksp} 0 {fa}"],
                  num2: ["{close}", "1 2 3", "4 5 6", "7 8 9", "{bksp} 0 {en}"],
                }}
                buttonTheme={[
                  {
                    class: "aClass",
                    buttons: "a \u0634",
                  },
                  {
                    class: "zClass",
                    buttons: "z \u0638",
                  },
                  {
                    class: "closeClass",
                    buttons: "{close} {num} {num1} {num2}",
                  },
                ]}
                theme={"hg-theme-default hg-theme-ios"}
                layoutName={this.state.keyboardLayoutName}
                onChange={(text) => {
                  console.log(text);
                  switch (this.state.currentInputTarget) {
                    case this.searchRef: {
                      this.setState({ searchValue: text });
                      break;
                    }
                    case this.quantityRef: {
                      this.quantityRef.current.value = text;
                      break;
                    }

                    default:
                      break;
                  }
                }}
                onKeyPress={(button) => {
                  switch (button) {
                    case "{num1}": {
                      this.setState(
                        {
                          keyboardLayoutName: "num1",
                        },
                        () => {
                          this.calculateKeyboardPos(
                            this.state.currentInputTarget
                          );
                        }
                      );
                      break;
                    }
                    case "{num2}": {
                      this.setState(
                        {
                          keyboardLayoutName: "num2",
                        },
                        () => {
                          this.calculateKeyboardPos(
                            this.state.currentInputTarget
                          );
                        }
                      );
                      break;
                    }
                    case "{fa}": {
                      this.setState(
                        {
                          keyboardLayoutName: "default",
                        },
                        () => {
                          this.calculateKeyboardPos(
                            this.state.currentInputTarget
                          );
                        }
                      );
                      break;
                    }
                    case "{en}": {
                      this.setState(
                        {
                          keyboardLayoutName: "en",
                        },
                        () => {
                          this.calculateKeyboardPos(
                            this.state.currentInputTarget
                          );
                        }
                      );
                      break;
                    }
                    case "{close}": {
                      let list = JSON.parse(
                        JSON.stringify(this.state.shoppingList)
                      );
                      list.forEach((element) => {
                        element.editQuantity = false;
                      });
                      this.setState({ shoppingList: list }, () => {
                        this.hideKeyboard();
                      });

                      break;
                    }
                    case "{confirm}": {
                      this.onConfirmQuantity();
                      break;
                    }

                    default:
                      break;
                  }
                }}
                mergeDisplay={true}
                display={{
                  "{bksp}": "⌫",
                  "{enter}": "⏎",
                  // "{shift}": "⇧",
                  // "{shiftactivated}": "⬆",
                  // "{tab}": "⇄",
                  "{num}": "123",
                  "{num1}": "123",
                  "{num2}": "123",
                  "{fa}": "🌐",
                  "{en}": "🌐",
                  "{close}": "🗙",
                  "{confirm}": "تایید",
                }}
              />
            </div>
          )}

          <Modal
            show={this.state.ModalTableShow}
            animation={false}
            onHide={() => {
              this.setState({ ModalTableShow: false });
            }}
            centered
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                maxWidth: "768px",
                fontSize: "24px",
                padding: "10px",
              }}
            >
              <div style={{ margin: "20px" }}>انتخاب ایستگاه</div>
              <div
                // className="tablesContainerGrid"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "10px",
                  padding: "10px",
                  maxHeight: "80vh",
                  overflow: "auto",
                }}
              >
                {this.state.tablesList.map((item, i) => {
                  return (
                    <TableItem
                      key={i}
                      onClick={() => {
                        this.setState(
                          {
                            selectedTableId: item.id,
                            selectedTableName: item.name,
                            ModalTableShow: false,
                          },
                          () => {
                            if (this.state.SubmitAfterTable) {
                              if (this.state.settlementType === 5) {
                                this.setState(
                                  { SubmitAfterCheckout: true },
                                  () => {
                                    this.setState({ ModalCheckout: true });
                                  }
                                );
                                return;
                              }
                              this.createUpdateOrder();
                            } else {
                              this.invoiceCalculator();
                            }
                          }
                        );
                      }}
                      title={item.name}
                      selected={this.state.selectedTableId === item.id}
                    />
                  );
                })}
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  marginTop: "30px",
                }}
              >
                <CustomButton
                  title="انصراف"
                  // disable={this.state.doneLoading}
                  img={Cancel}
                  backColor="var(--black1)"
                  onClick={() => {
                    this.setState({ ModalTableShow: false });
                  }}
                />
              </div>
            </div>
          </Modal>

          <Modal
            show={this.state.ModalCheckout}
            animation={false}
            onHide={() => {
              this.setState({ ModalCheckout: false });
            }}
            centered
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                maxWidth: "768px",
                fontSize: "24px",
                padding: "10px",
              }}
            >
              <div style={{ margin: "20px" }}>انتخاب نوع پرداخت</div>
              <div
                style={{
                  // display: "flex",
                  // flexDirection: "row",
                  // flexWrap: "wrap",
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  width: "100%",
                  gap: "20px",
                  padding: "20px",
                  maxHeight: "80vh",
                  overflow: "auto",
                }}
              >
                <div
                  className={
                    this.state.settlementType === 1
                      ? "checkoutTypeButtonSelected"
                      : "checkoutTypeButton"
                  }
                  onClick={() => {
                    this.onSelectCheckout(1);
                    // this.setState({ settlementType: 1, ModalCheckout: false });
                  }}
                >
                  نقدی
                </div>
                <div
                  className={
                    this.state.settlementType === 2
                      ? "checkoutTypeButtonSelected"
                      : "checkoutTypeButton"
                  }
                  onClick={() => {
                    this.onSelectCheckout(2);
                    // this.setState({ settlementType: 2, ModalCheckout: false });
                  }}
                >
                  کارتخوان
                </div>
                <div
                  className={
                    this.state.settlementType === 4
                      ? "checkoutTypeButtonSelected"
                      : "checkoutTypeButton"
                  }
                  onClick={() => {
                    this.onSelectCheckout(4);
                  }}
                >
                  ترکیبی
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  marginTop: "30px",
                }}
              >
                <CustomButton
                  title="انصراف"
                  // disable={this.state.doneLoading}
                  img={Cancel}
                  backColor="var(--black1)"
                  onClick={() => {
                    this.setState({ ModalCheckout: false });
                  }}
                />
              </div>
            </div>
          </Modal>

          <Modal
            show={this.state.ModalInfoShow}
            animation={false}
            onHide={() => {
              this.setState({ ModalInfoShow: false });
            }}
            centered
          >
            <div className="settingContainer">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  overflow: "auto",
                  marginTop: "20px",
                  padding: "5px",
                  width: "100%",
                }}
              >
                <div className="settingItemContainer">
                  <div className="settingLabel">تلفن همراه</div>
                  <Form.Control
                    maxLength="11"
                    className={
                      this.state.mobileValueErrorText !== ""
                        ? "inputStyleForm inputError textAlignCenter"
                        : "inputStyleForm textAlignCenter"
                    }
                    placeholder="مثال: 09123456789"
                    style={{ maxWidth: "200px" }}
                    type="text"
                    // name="mobileValue"
                    // onChange={this.textHandleChange.bind(this)}
                    // value={this.state.mobileValue}
                    ref={this.mobileRef}
                  />
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="تایید"
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={() => {
                      this.setState(
                        {
                          mobileValue: this.mobileRef.current.value,
                          ModalInfoShow: false,
                        },
                        () => {
                          this.invoiceCalculator();
                        }
                      );
                    }}
                    loading={this.state.doneLoading}
                  />
                </div>
                <div style={{ minWidth: "10px" }} />
                <div style={{ flex: "0.8" }}>
                  <CustomButton
                    title="انصراف"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    disable={this.state.doneLoading}
                    img={Cancel}
                    onClick={() => {
                      this.setState({ ModalInfoShow: false });
                    }}
                  />
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            show={this.state.ModalDesShow}
            animation={false}
            onHide={() => {
              this.setState({ ModalDesShow: false });
            }}
            centered
          >
            <div className="settingContainer">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  overflow: "auto",
                  marginTop: "20px",
                  padding: "5px",
                  width: "100%",
                }}
              >
                <div className="settingItemContainer">
                  <div className="settingLabel">توضیحات</div>
                  <Form.Control
                    className="inputStyleForm rtlStyle"
                    type="text"
                    as="textarea"
                    style={{
                      maxWidth: "300px",
                      minHeight: "60px",
                      direction: "rtl",
                    }}
                    ref={this.desRef}
                  />
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="تایید"
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={() => {
                      this.setState(
                        { desValue: this.desRef.current.value },
                        () => {
                          this.setState({ ModalDesShow: false });
                        }
                      );
                    }}
                  />
                </div>
                <div style={{ minWidth: "10px" }} />
                <div style={{ flex: "0.8" }}>
                  <CustomButton
                    title="انصراف"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    // disable={this.state.doneLoading}
                    img={Cancel}
                    onClick={() => {
                      this.setState({ ModalDesShow: false });
                    }}
                  />
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            show={this.state.ModalGuestsShow}
            animation={false}
            onHide={() => {
              this.setState({ ModalGuestsShow: false });
            }}
            centered
          >
            <div className="settingContainer">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  overflow: "auto",
                  marginTop: "20px",
                  padding: "5px",
                  width: "100%",
                }}
              >
                <div className="settingItemContainer">
                  <div className="settingLabel">تعداد میهمان</div>
                  <Form.Control
                    className="inputStyleForm"
                    type="text"
                    // as="textarea"
                    style={{
                      maxWidth: "100px",
                      // minHeight: "60px",
                      // direction: "rtl",
                    }}
                    ref={this.guestsRef}
                  />
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="تایید"
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={() => {
                      this.setState(
                        {
                          numberOfGuests: this.guestsRef.current.value
                            ? this.guestsRef.current.value
                            : null,
                        },
                        () => {
                          this.setState({ ModalGuestsShow: false });
                        }
                      );
                    }}
                  />
                </div>
                <div style={{ minWidth: "10px" }} />
                <div style={{ flex: "0.8" }}>
                  <CustomButton
                    title="انصراف"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={() => {
                      this.setState({ ModalGuestsShow: false });
                    }}
                  />
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            show={this.state.ModalDeleteChanges}
            animation={false}
            onHide={() => {
              this.setState({ ModalDeleteChanges: false });
            }}
            centered
          >
            <div className="dialogBox">
              تغییرات سبد خرید حذف شود؟
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="خیر"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={() => {
                      this.setState({ ModalDeleteChanges: false });
                    }}
                  />
                </div>
                <div style={{ minWidth: "5px" }} />
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="بله"
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={this.DeleteChangesConfirm.bind(this)}
                  />
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            show={this.state.ModalDeleteOrder}
            animation={false}
            onHide={() => {
              this.setState({ ModalDeleteOrder: false });
            }}
            centered
          >
            <div className="dialogBox">
              آیا مطمئن به ابطال این سفارش با شماره فاکتور{" "}
              {this.state.currentOrderId} می‌باشید؟
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="خیر"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={() => {
                      this.setState({ ModalDeleteOrder: false });
                    }}
                  />
                </div>
                <div style={{ minWidth: "5px" }} />
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="بله"
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={this.deleteOrder.bind(this)}
                  />
                </div>
              </div>
            </div>
          </Modal>
        </div>
      );
    } else {
      return (
        <div
          className="Login"
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            backgroundColor: "var(--gray1)",
            zIndex: "1",
          }}
        >
          <Loading />
        </div>
      );
    }
  }
}
